import { Component } from '@angular/core';
import { IToken } from '@shared/interfaces/token.interface';
import { StorageService } from '@shared/services/storage.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from '@shared/services/profile.service';
import { UserTypeEnum } from '@shared/enums/user-type.enum';
import { IUser } from '@shared/interfaces/user.interface';
import { FormBuilder, FormControl, FormGroup, Validators } from '@node_modules/@angular/forms';
import { AuthService } from '@shared/services/auth.service';
import { LoginModel } from '@shared/models/login.model';
import { environment } from 'src/environments/environment';
import { UserTypeNameEnum } from '@shared/enums/partner-type.enum';
@Component({
  selector: 'hadsup-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent  {
  loadingData = false;
  userProfile: IUser = {} as IUser;
  investQuantity = '';
  roleType: any;
  loginForm: FormGroup | any;
  passwordType = 'password';
  isPassword: boolean = false;
  isLoading: boolean = false;
  submitted: boolean = false;
  HomePage = `${environment.hadsup_home_url}`;
  constructor(
    private router: Router,
    private storageService: StorageService,
    private profileService: ProfileService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private authService: AuthService,
  ) {
    const userInformation = {
      email: '',
      password: '',
    };
    this.loginForm = fb.group({
      email: new FormControl(userInformation.email, [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
      password: new FormControl(userInformation.password, [Validators.required, Validators.minLength(8)]),
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  GetProfileDetails() {
    this.loadingData = true;
    this.profileService.GetProfile().subscribe(
      (response: any) => {
        if (response && response.data) {
          const user = response.data;
          const restrictRole = user.permissions.filter((f: any) => f === 'franchise');
          if (restrictRole[0] === 'franchise') {
            this.toaster.warning('You are not authorized to access this page', 'Unauthorized!');
            this.storageService.removeAll();
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 1000);
          }
          else {
            this.userProfile = response.data;
            this.storageService.setUserInfo(user);
            this.storageService.setProfileInfo(this.userProfile);
            this.openWebApp()
          }
        }
      },
    );
  }
  login() {
    this.storageService.removeAll()
    if (this.isLoading) {
      this.submitted = false;
      return;
    }
    this.submitted = true;
    if (this.loginForm.valid) {
      this.isLoading = true;
      const submittedForm: any = this.loginForm.value as LoginModel;
      this.isLoading = true;
      this.authService.Login(submittedForm).subscribe(
        (response) => {
          if (response) {
            if(!response.data.permissions.includes(UserTypeNameEnum.LocationOwner)){
              this.toaster.warning('You are not authorized to access this page', 'Unauthorized!');
              return;
            }
            this.setSessionValues(response);
            this.toaster.success("You are successfully logged in", 'Success');
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.submitted = false;
          this.isLoading = false;
          // this.toaster.error(error.error.errors[0].errors, 'Error');
          this.storageService.removeAccessToken()
        }).add(() => {
          this.isLoading = false;
          this.submitted = false;
        });
    }
  }
  setSessionValues(response: any) {
    const token: IToken = {
      access_token: response.access_token,
      refresh_token: response.refresh_token,
      expires_in: Date.now() + response.expires_in * 1000,
      token_type: 'Bearer',
    };

    this.storageService.setAccessToken(token);
    this.storageService.setUserInfo(response.data);
    this.profileService.GetProfile().subscribe((res: any) => {
      this.userProfile = res.data;
      localStorage.setItem('User', JSON.stringify(res.data));
      localStorage.setItem('Profile', JSON.stringify(res.data));
    });
    this.GetProfileDetails();
  }
  openWebApp() {
    const roles = this.userProfile?.relations?.roles;
    if (roles) {
      if (roles.findIndex((f) => f.id == UserTypeEnum.LocationOwner) > -1) {
        this.router.navigateByUrl('landlord/overview');
      }       
      else {
        this.storageService.removeProfileInfo();
        this.storageService.removeUserInfo();
        this.storageService.removeAccessToken();
        this.router.navigateByUrl('/login');
      }
    }
    this.loadingData = false;
  }
  passwordHideShow(type: string) {
    if (type === 'PASSWORD') {
      this.isPassword = !this.isPassword;
      this.passwordType = this.isPassword ? 'text' : 'password';
    }
  }

}
